import PortalIndex from "../components/portal/PortalIndex";
import SampleScheduleReport from "../components/portal/SampleScheduleReport";
import FileUploadPage from "../components/portal/fileUpload/FileUploadPage";
import LeadServiceLineIndex from "../components/portal/leadServiceLineIndex";

export const portalRoutes = [
  {
    path: "/portal/portal-index",
    component: PortalIndex
  },
  {
    path: "/portal/lead-service-line-index",
    component: LeadServiceLineIndex
  },
  {
    path: "/portal/file-upload",
    component: FileUploadPage
  },
  {
    path: "/portal/sample-schedule-report",
    component: SampleScheduleReport
  }
];
